import { CloseRounded, NavigateBeforeRounded, NavigateNextRounded } from "@mui/icons-material";
import { Box, Button, CircularProgress, Dialog, IconButton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useEffect, useRef, useState } from "react";
import { GlobalState } from "context/GlobalContext";
import EditDetailsContent from "./EditDetailsContent/EditDetailsContent";

const EditDetailsModal = ({
	modal,
	setModal,
	selectedColor,
	setSelectedColor,
	saveCallback,
	currentIndex = 0,
	totalCount = 0,
	onPrev = () => {},
	onNext = () => {},
}) => {
	const { setLoadingOpen } = GlobalState();
	const [busy, setBusy] = useState(false);
	const [navBusy, setNavBusy] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const [canPublish, setCanPublish] = useState(false);
	const headerActionsRef = useRef({ publish: () => {} });

	useEffect(() => {
		if (modal) setIsEditMode(false);
	}, [modal, selectedColor?.option_id]);

	const handleModalClose = () => {
		setNavBusy(false);
		setBusy(false);
		setLoadingOpen(false);
		setModal(false);
		setSelectedColor();
	};

	const handleCancelEdit = () => {
		setIsEditMode(false);
	};

	const handleEnterEdit = () => {
		setIsEditMode(true);
	};

	const handleBusyChange = (childBusy) => {
		setBusy(!!childBusy);
		if (childBusy) setNavBusy(false);
	};

	const isBusy = busy || navBusy;

	const handlePrevClick = () => {
		if (isBusy || isEditMode || currentIndex <= 0) return;
		setNavBusy(true);
		setLoadingOpen(true);
		onPrev();
	};

	const handleNextClick = () => {
		if (isBusy || isEditMode || currentIndex >= totalCount - 1) return;
		setNavBusy(true);
		setLoadingOpen(true);
		onNext();
	};

	const isPublished = selectedColor?.buy_qty_status === "PUBLISHED";

	return (
		<Dialog fullWidth maxWidth="xl" open={modal} onClose={handleModalClose} scroll="paper" PaperProps={{ sx: { height: "92vh" } }}>
			<Box sx={{ height: "100%", p: 2, overflow: "hidden" }}>
				<Box display="flex" justifyContent="space-between" alignItems="center" gap={1} flexWrap="wrap">
					<Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
						<Typography variant="h6">Edit Buy Qty</Typography>
						<Typography variant="body2" color={grey[600]}>
							{totalCount ? currentIndex + 1 : 0} / {totalCount}
						</Typography>
					</Box>
					<Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
						<Button
							variant="contained"
							color="success"
							onClick={() => headerActionsRef.current?.publish?.()}
							disabled={isBusy || isEditMode || isPublished || !canPublish}>
							Publish
						</Button>
						<Button
							variant="outlined"
							startIcon={isBusy ? <CircularProgress size={16} color="inherit" /> : <NavigateBeforeRounded />}
							onClick={handlePrevClick}
							disabled={isBusy || isEditMode || currentIndex <= 0}>
							Prev
						</Button>
						<Button
							variant="outlined"
							endIcon={isBusy ? <CircularProgress size={16} color="inherit" /> : <NavigateNextRounded />}
							onClick={handleNextClick}
							disabled={isBusy || isEditMode || currentIndex >= totalCount - 1}>
							Next
						</Button>
						<IconButton aria-label="close" onClick={handleModalClose} disabled={isBusy}>
							<CloseRounded />
						</IconButton>
					</Box>
				</Box>

				<EditDetailsContent
					modal={modal}
					selectedColor={selectedColor}
					saveCallback={saveCallback}
					onClose={handleModalClose}
					onCancelEdit={handleCancelEdit}
					onExitEdit={handleCancelEdit}
					onEnterEdit={handleEnterEdit}
					onBusyChange={handleBusyChange}
					isEditMode={isEditMode}
					onRegisterActions={(actions) => {
						headerActionsRef.current = actions ?? { publish: () => {} };
						setCanPublish(!!actions?.canPublish);
					}}
				/>
			</Box>
		</Dialog>
	);
};

export default EditDetailsModal;
